import { PreviewStatus } from '../../../../../core/records/entities/metadata/metadata.entity';
import { NavigationLink } from '../../../../../elements/public_api';
import { Cell, CellType } from '../_base/table-cell.entity';

export interface MediaCellInterface {
    title: string;
    imgSrc?: string;
    imgAlt?: string;
    info?: string;
    navigationLink?: NavigationLink;
    detailUrl?: string;
    previewStatus?: PreviewStatus;
}

export class MediaCell extends Cell implements MediaCellInterface {
    public title: string;
    public imgSrc?: string;
    public imgAlt?: string;
    public info?: string;
    public navigationLink?: NavigationLink;
    public detailUrl?: string;
    public previewStatus?: PreviewStatus = PreviewStatus.Ready;

    constructor({ title, imgSrc, imgAlt, info, navigationLink, detailUrl, previewStatus }: MediaCellInterface) {
        super(CellType.MEDIA);
        this.title = title;
        this.imgSrc = imgSrc;
        this.imgAlt = imgAlt;
        this.info = info;
        this.navigationLink = navigationLink;
        this.detailUrl = detailUrl;
        this.previewStatus = previewStatus;
    }
}
